import { Heading, Text } from '@soteria/design-system-ve';

import type { PolicySummaryMetrics } from '../../domain/audit-report-types';
import * as reportStyles from '../../pages/AuditReportPage.css';

interface PolicySummaryPanelProps {
  policySummary: PolicySummaryMetrics;
}

export function PolicySummaryPanel({ policySummary }: PolicySummaryPanelProps) {
  return (
    <div>
      <Heading level="h4">Policy Assessment Summary</Heading>
      <div className={reportStyles.comparisonGrid}>
        <div className={reportStyles.comparisonCard}>
          <Text className={reportStyles.comparisonLabel}>TOTAL POLICIES ASSESSED</Text>
          <Text className={`${reportStyles.comparisonValue} ${reportStyles.policyCorrectnessValue}`}>{policySummary.totalPoliciesAssessed}</Text>
        </div>
        <div className={reportStyles.comparisonCard}>
          <Text className={reportStyles.comparisonLabel}>TRIGGERED POLICIES</Text>
          <Text className={`${reportStyles.comparisonValue} ${reportStyles.policyCorrectnessValue}`}>
            {policySummary.triggeredPoliciesCount} ({(policySummary.triggeredPoliciesCorrectPercentage * 100).toFixed(1)}% correct)
          </Text>
        </div>
        <div className={reportStyles.comparisonCard}>
          <Text className={reportStyles.comparisonLabel}>NON-TRIGGERED POLICIES</Text>
          <Text className={`${reportStyles.comparisonValue} ${reportStyles.policyCorrectnessValue}`}>
            {policySummary.nonTriggeredPoliciesCount} ({(policySummary.nonTriggeredPoliciesCorrectPercentage * 100).toFixed(1)}% correct)
          </Text>
        </div>
        <div className={reportStyles.comparisonCard}>
          <Text className={reportStyles.comparisonLabel}>TRIGGERED CORRECT</Text>
          <Text className={`${reportStyles.comparisonValue} ${reportStyles.labelCorrectnessValue}`}>
            {policySummary.triggeredPoliciesCorrectCount} / {policySummary.triggeredPoliciesCount}
          </Text>
        </div>
        <div className={reportStyles.comparisonCard}>
          <Text className={reportStyles.comparisonLabel}>NON-TRIGGERED CORRECT</Text>
          <Text className={`${reportStyles.comparisonValue} ${reportStyles.labelCorrectnessValue}`}>
            {policySummary.nonTriggeredPoliciesCorrectCount} / {policySummary.nonTriggeredPoliciesCount}
          </Text>
        </div>
      </div>
    </div>
  );
}
